import React from "react";
import "./SponsorLogosBand.css";

// Manifest is GSO-only. On other brands the JSON may be absent; require
// safely and fall back to an empty manifest.
let manifest = { heading: "", logos: [] };
try {
  // eslint-disable-next-line global-require
  manifest = require("../../data/brands/gso-sponsors.json");
} catch (e) {
  manifest = { heading: "", logos: [] };
}

export default function SponsorLogosBand() {
  const logos = (manifest && manifest.logos) || [];
  if (!logos.length) return null;
  const heading = (manifest && manifest.heading) || "Sponsors and Partners";
  return (
    <section
      className="sponsor-logos-band section-padding"
      role="region"
      aria-label="Sponsors and Partners"
    >
      <div className="container">
        <h2 className="sponsor-logos-band__heading">{heading}</h2>
        <ul className="sponsor-logos-band__grid">
          {logos.map((logo) => {
            const src = `/assets/brand/gso/sponsors/${logo.filename}`;
            const alt = logo.alt || logo.filename.replace(/\.[a-z0-9]+$/i, "").replace(/[-_]+/g, " ");
            const img = (
              <img
                src={src}
                alt={alt}
                loading="lazy"
                width={logo.width || undefined}
                height={logo.height || undefined}
              />
            );
            return (
              <li key={logo.filename} className="sponsor-logos-band__item">
                {logo.href ? (
                  <a href={logo.href} target="_blank" rel="noopener noreferrer" aria-label={alt}>
                    {img}
                  </a>
                ) : (
                  img
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
